import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Parallax } from "./Parallax";
export var HoverEvent = /*#__PURE__*/function () {
  function HoverEvent() {
    _classCallCheck(this, HoverEvent);

    this.enable = false;
    this.mode = [];
    this.parallax = new Parallax();
  }

  _createClass(HoverEvent, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }

      this.parallax.load(data.parallax);
    }
  }]);

  return HoverEvent;
}();